// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-components-PageBody---wrapper---2XkL9","main":"src-components-PageBody---main---Aii-g","main_body":"src-components-PageBody---main_body---P_JXB"};